import { apiGet, apiUpdate } from "../../../API/Service/apiClient";

export const handleGetSize_list = async(
  {filter,setSizeData,setLoading,pid}) => {
  setLoading(true);
  try {
    const resData = await apiGet("product-size", filter);
    const resDataProduct = await apiGet("single_product_size",
     {pid:pid,page:1,limit:100});         
     
    if(resDataProduct?.data.length > 0){
      const merged = resData?.data?.map(tItem => {
        const match = resDataProduct?.data?.find(sItem => sItem.sid === tItem.sid);
      
        return match
          ? { ...tItem, ch_price: match.ch_price, ch_mrp: match.ch_mrp }
          : tItem; // unchanged if no match
      });
      setSizeData(merged);
    }else{
      setSizeData(resData?.data);
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleEdit = (index, key, value,
  sizeData,setSizeData) => {
  if(index===0){
    const updatedData = sizeData.map(item => ({
      ...item,
      [key]: value,      
    }));
    setSizeData(updatedData);
  }else{
    const updated = [...sizeData];
    updated[index][key] = value;
    setSizeData(updated);
  }  
  
};

const extractAndAdd = (array, keysToKeep, newKeys) => {
  return array.map(item => {
    const selected = keysToKeep.reduce((acc, key) => {
      acc[key] = item[key];
      return acc;
    }, {});
    return { ...selected, ...newKeys };
  });
};

export const handleSubmit_sizes = async (
  {sizeData,setIsLoading,pid}) => {
  setIsLoading(true);
  const result = extractAndAdd(sizeData, ['subid', 'sid','ch_price','ch_mrp'], { pid: pid });  
  try {     
    let data={
      sizes: result,
      action: "update_size",
    }
    const resData = await apiUpdate("single_product_size",data);
    alert("Data saved successfully!");    
  } catch (error) {
    console.error("Error saving order", error);
  } finally {
    setIsLoading(false);
  }
};